import React from "react";
import { Box, Button, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../../components/Table/DataTable";
import { IBusinessPolicyEquipment } from "../../../../../../../redux/businessPolicy/businessPolicyEquipment/businessPolicyEquipment.types";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import { LoadState } from "../../../../../../../constants/enums";
import { useDispatchWrapper } from "../../../../../../../hooks";
import { fetchBusinessPolicyEquipmentListAsync } from "../../../../../../../redux/businessPolicy/businessPolicyEquipment/businessPolicyEquipmentActions";
import { StandardTableActions } from "../../../../../../../components/StandardTableActions/StandardTableActions";
import { fetchLifeInsuranceFamilyTreeListAsync } from "../../../../../../../redux/lifeInsurancePolicy/lifeInsurancePolicyFamilyTree/lifeInsurancePolicyFamilyTreeActions";
import { ILifeInsurancePolicyFamilyTree } from "../../../../../../../redux/lifeInsurancePolicy/lifeInsurancePolicyFamilyTree/lifeInsurancePolicyFamilyTree.types";

export const LifeInsuranceFamilyTreeList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.lifeInsurance.familyTree
  );
  const dispatch = useDispatchWrapper();
  const fetchList = async () => {
    dispatch(fetchLifeInsuranceFamilyTreeListAsync(customerPolicyId));
  };

  React.useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPolicyId]);

  const familyTreeTableProps: IDataTableProps = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    `/life-insurance-policy/${customerId}/additional-information-tab/${customerPolicyId}/family`
                  );
                }}
              >
                Add Family
              </Button>
            ),
          },
        ],
      },
    },
    columns: [
      {
        key: "serial_number",
        headerName: "#",
        fieldName: "serial_number",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,
        onRowCellRender: (value, row: ILifeInsurancePolicyFamilyTree) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/life-insurance-policy/${customerId}/additional-information-tab/${customerPolicyId}/family/${row.serial_number}`
                );
              }}
            >
              {row.serial_number}
            </Link>
          );
        },
      },
      {
        key: "name",
        headerName: "Name",
        fieldName: "name",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },

      {
        key: "email",
        headerName: "Email",
        fieldName: "email",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "marital_status",
        headerName: "Martial Status",
        fieldName: "marital_status",
        renderType: RenderType.TEXT,
        exportCellWidth: 25,
      },

      {
        key: "insurer",
        headerName: "Insurer",
        fieldName: "insurer",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },
      {
        key: "relationship_to_owner",
        headerName: "Relationship to Owner",
        fieldName: "relationship_to_owner",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },

      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ILifeInsurancePolicyFamilyTree) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                navigate(
                  `/life-insurance-policy/${customerId}/additional-information-tab/${customerPolicyId}/family/${row.serial_number}`
                );
              }}
            />
          );
        },
      },
    ],
    items: data,
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <DataTable {...familyTreeTableProps} />
      </Box>
    </>
  );
};
